<template>
  <div>
    <card
      :title="$t('delete-account.delete-account-dialog.title')"
      transparent
    >
      <div class="p-description">
        {{ description }}
      </div>
      <template
        v-if="isDeleteButtonShown"
        #footer
      >
        <el-button
          type="secondary"
          @click="toggleDeleteDialog(true)"
        >
          {{ $t('action.delete-account') }}
        </el-button>
      </template>
    </card>
    <delete-account-dialog
      v-if="dialogOpen"
      :type="type"
      @hide="toggleDeleteDialog(false)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/app/components/Card';
import DeleteAccountDialog from '@/app/components/delete-account/DeleteAccountDialog';
import { Permissions } from '@/app/services/UserPermissionsService';

export default {
  name: 'DeleteAccountCard',
  components: {
    Card,
    DeleteAccountDialog
  },
  props: {
    type: {
      type: String,
      default: 'company'
    }
  },
  data() {
    return {
      dialogOpen: false
    };
  },
  computed: {
    ...mapGetters('app', [
      'hasUserPermissions'
    ]),
    description() {
      return this.type === 'company' ? this.$t('profile.delete-account.description') : this.$t('consumer-profile.delete-account.description');
    },
    isDeleteButtonShown() {
      return this.type === 'consumer' ? true : this.hasUserPermissions(Permissions.deleteAccount);
    }
  },
  methods: {
    toggleDeleteDialog(open) {
      this.dialogOpen = open;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-description {
  padding: 24px;
}
</style>
